import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/HomeV2.vue') },
  {
    path: '/about',
    name: 'About',
    redirect: '/about/profile',
    component: () => import('@/views/About/IndexV2.vue'),
    children: [
      { path: 'profile', name: 'AboutProfile', component: () => import('@/views/About/ProfileV2.vue') },
      { path: 'structure', name: 'AboutStructure', component: () => import('@/views/About/StructureV2.vue') },
      { path: 'culture', name: 'AboutCulture', component: () => import('@/views/About/CultureV2.vue') },
      { path: 'honors', name: 'AboutHonors', component: () => import('@/views/About/HonorsV2.vue') }
    ]
  },
  {
    path: '/news',
    name: 'News',
    redirect: '/news/list',
    component: () => import('@/views/News/IndexV2.vue'),
    children: [
      { path: 'list', name: 'NewsList', component: () => import('@/views/News/ListV2.vue') },
      { path: 'internal', name: 'NewsInternal', component: () => import('@/views/News/InternalV2.vue') },
      { path: 'safety', name: 'NewsSafety', component: () => import('@/views/News/SafetyV2.vue') },
      { path: 'detail/:id', name: 'NewsDetail', component: () => import('@/views/News/DetailV2.vue') }
    ]
  },
  {
    path: '/cases',
    name: 'Cases',
    redirect: '/cases/debug',
    component: () => import('@/views/Cases/IndexV2.vue'),
    children: [
      { path: 'debug', name: 'CasesDebug', component: () => import('@/views/Cases/DebugV2.vue') },
      { path: 'debug/:id', name: 'DebugDetail', component: () => import('@/views/Cases/CaseDetailV2.vue') },
      { path: 'operation', name: 'CasesOperation', component: () => import('@/views/Cases/OperationV2.vue') },
      { path: 'operation/:id', name: 'OperationDetail', component: () => import('@/views/Cases/CaseDetailV2.vue') }
    ]
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    redirect: '/enterprise/stars',
    component: () => import('@/views/Enterprise/IndexV2.vue'),
    children: [
      { path: 'stars', name: 'EntStars', component: () => import('@/views/Enterprise/StarsV2.vue') },
      { path: 'stars/:id', name: 'StarsDetail', component: () => import('@/views/Enterprise/StarsDetailV2.vue') },
      { path: 'staff', name: 'EntStaff', component: () => import('@/views/Enterprise/StaffV2.vue') },
      { path: 'staff/:id', name: 'StaffDetail', component: () => import('@/views/Enterprise/StaffDetailV2.vue') }
    ]
  },
  { path: '/contact', name: 'Contact', component: () => import('@/views/ContactV2.vue') },
  { path: '/mail', name: 'Mail', component: () => import('@/views/MailV2.vue') },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
